<div class="relative">
  <input [readOnly]="isReadonly" class="form-input relative form-focus-visible" [ngClass]="getClasses()" [type]="type" [id]="htmlId" [formControl]="control" [placeholder]="placeholder" [autocomplete]="autocomplete" (blur)="onBlur()" #input />
  <div class="absolute inset-y-0 h-full px-3 flex items-center text-icon-actions" *ngIf="type === 'search'">
    <lis-icon [name]="'action_search-20'"></lis-icon>
  </div>
  <button class="absolute inset-y-0 my-auto h-full flex items-center right-0 px-3 text-input-outline-focused" type="button" *ngIf="isResetVisible()" (click)="onResetClick()">
    <lis-icon [name]="'action_close-20'"></lis-icon>
  </button>
</div>
